module.exports = __webpack_public_path__ + "dc0d5bfce4986880c5066d29c0f83a2f.svg";